// @ts-check
import GitTypes from 'common/constants/GitTypes';
import {
  AzureDevopsLogo,
  BitbucketLogo,
  GithubLogo,
  GitlabLogo
} from '@linearb/linui-common';

/**
 * @typedef {object} FormData
 * @property {string} full_name Full name
 * @property {string} work_email Email address
 * @property {string} role User role
 * @property {string} team_size Team size
 * @property {boolean} enable_email_notifications Enable email notifications
 */

export const AUTH_METHODS = /** @type {const} */ ({
  PAT: 'pat',
  OAUTH: 'oAuth'
});

export const GIT_PROVIDERS_CONFIG = /** @type {const} */ ({
  [GitTypes.GITHUB]: {
    name: 'GITHUB',
    logo: <GithubLogo />,
    [AUTH_METHODS.PAT]: true,
    [AUTH_METHODS.OAUTH]: true
  },
  [GitTypes.GITLAB]: {
    name: 'GITLAB',
    logo: <GitlabLogo />,
    [AUTH_METHODS.PAT]: true,
    [AUTH_METHODS.OAUTH]: true
  },
  [GitTypes.BITBUCKET]: {
    name: 'BITBUCKET',
    logo: <BitbucketLogo />,
    [AUTH_METHODS.PAT]: false,
    [AUTH_METHODS.OAUTH]: true
  },
  [GitTypes.AZURE_DEVOPS]: {
    name: 'AZURE',
    logo: <AzureDevopsLogo />,
    [AUTH_METHODS.PAT]: true,
    [AUTH_METHODS.OAUTH]: false
  }
});

export const ROLES = /** @type {const} */ ({
  VP: 'VP / CTO',
  PLATFORM_ENG: 'Platform Eng / DX',
  DIRECTOR: 'Director / Manager',
  TEAM_LEAD: 'Team Lead',
  DEVELOPER: 'Developer',
  OTHER: 'Other'
});

export const SIZES = [
  { value: '0-50', label: '0-50' },
  { value: '51-100', label: '51-100' },
  { value: '101-250', label: '101-250' },
  { value: '251-500', label: '251-500' },
  { value: '500-1000', label: '500-1,000' },
  { value: '1001+', label: '1,001+' }
];

export const FORM_VALUES = /** @type {const} */ ({
  FULL_NAME: 'full_name',
  WORK_EMAIL: 'work_email',
  ROLE: 'role',
  TEAM_SIZE: 'team_size',
  ENABLE_EMAIL_NOTIFICATIONS: 'enable_email_notifications'
});

export const VALIDATION_MESSAGES = /** @type {const } */ ({
  [FORM_VALUES.FULL_NAME]: {
    required: 'Required',
    maxLength: 'Name length cannot exceed 100 characters',
    pattern: 'Please enter a valid name'
  },
  [FORM_VALUES.WORK_EMAIL]: {
    required: 'Required',
    validate: 'Please enter a valid email address',
    nonWorkEmail: 'Please provide your work email'
  }
});

export const FULL_NAME_PATTERN =
  /^[A-Za-z][A-Za-z\s\-'\`]+([\ A-Za-z][A-Za-z\s\-'\`]+)*$/;
export const INVALID_ZEROBOUNCE_STATUSES = ['invalid', 'spamtrap', 'abuse'];
export const INVALID_ZEROBOUNCE_SUB_STATUSES = [
  'blocked',
  'disposable',
  'toxic',
  'mx_forward',
  'global_suppression'
];
